/**
 * wlChips.js — ЕДИНЫЙ каталог чипов окна/уровня. БЕЗ ЕДИНОГО ИМПОРТА —
 * сознательно (приём printUtil/wlManual): чистые данные и чистые функции,
 * проверяемые без DOM и без заглушек.
 *
 * ПОВОД [11.1.17], аудит §2.2: гридов чипов было ДВА рукописных (правая
 * панель и мобильный ящик), и они уже разъехались — в мобильном пропали
 * Средостение, Височная кость, Таз, PET, US, рентген-Кости/Мягк. и, больнее
 * всего, «Ангио (кино)» с авто-окном: именно на телефоне, где ангио-кино и
 * смотрят. Третьим источником тех же понятий жила _QUICK_WL в
 * viewportKeyboard со СВОИМИ числами (Кости там были 2000/300 против 2500/480
 * на чипе — дрейф №4). Теперь источник один: оба грида РЕНДЕРЯТСЯ отсюда
 * (sidebarBindings.построитьЧипыОкон), быстрые клавиши берут числа отсюда же,
 * а шкала ручных ползунков выводится из максимумов каталога (§2.1: чип
 * PET 30000/15000 не помещался в зашитые max 8000/4000 — при том что
 * wlmanual_test прямо пиннит «у ПЭТ — тысячи»).
 *
 * МРТ [11.1.17], аудит §2.3: интенсивности МР произвольны по аппарату —
 * «одно число на все аппараты не подберёшь» (довод 10.3.2, по которому XA
 * получил перцентильное авто-окно). Четвёрка T1/T2/FLAIR/DWI переведена на
 * тот же механизм: auto:'percentile', а прежние числа оставлены ЗАТРАВКОЙ —
 * применяются с оговоркой, только пока кадр не готов.
 *
 * Реестр windowPresets («Quantum», BUILTIN_PRESETS) НЕ дублируется и не
 * трогается: он — движок сценариев и авторекомендаций по тегам; каталог ниже
 * — источник КНОПОК панели. Сверять их держит пин verify_11_1_17.
 */

/** @typedef {{id:string,label:string,ww?:number,wc?:number,auto?:'percentile',title?:string}} ЧипОкна */

const _ГРУППЫ = [
  {
    ключ: 'ct', заголовок: 'CT', чипы: [
      { id: 'ct-abdomen',    label: 'Живот',          ww: 400,   wc: 40 },
      { id: 'ct-lung',       label: 'Лёгкие',         ww: 1500,  wc: -600 },
      { id: 'ct-bone',       label: 'Кости',          ww: 2500,  wc: 480 },
      { id: 'ct-brain',      label: 'Мозг',           ww: 80,    wc: 40 },
      { id: 'ct-stroke',     label: 'Инсульт',        ww: 40,    wc: 40 },
      { id: 'ct-subdural',   label: 'Субдурал',       ww: 200,   wc: 80 },
      { id: 'ct-soft',       label: 'Мягк. ткани',    ww: 350,   wc: 50 },
      { id: 'ct-liver',      label: 'Печень',         ww: 150,   wc: 30 },
      { id: 'ct-mediastinum',label: 'Средостение',    ww: 350,   wc: 50 },
      { id: 'ct-pe',         label: 'ТЭЛА',           ww: 700,   wc: 100 },
      { id: 'ct-temporal',   label: 'Височная кость', ww: 4000,  wc: 700 },
      { id: 'ct-spine',      label: 'Позвоноч.',      ww: 300,   wc: 40 },
      { id: 'ct-angio',      label: 'Ангио',          ww: 600,   wc: 170 },
      { id: 'ct-chest',      label: 'Грудная кл.',    ww: 400,   wc: 40 },
      { id: 'ct-pelvis',     label: 'Таз',            ww: 400,   wc: 40 },
    ],
  },
  {
    ключ: 'mri', заголовок: 'MRI', чипы: [
      // auto: окно считается по 1–99 перцентилю кадра; числа — лишь затравка
      // на случай «кадр ещё не готов», с оговоркой в тосте.
      { id: 'mr-t1',    label: 'T1',    auto: 'percentile', ww: 500,  wc: 250,
        title: 'Окно по самому кадру (1–99 перцентиль): интенсивности МР произвольны по аппарату. Числа 500/250 — лишь затравка, пока кадр не готов' },
      { id: 'mr-t2',    label: 'T2',    auto: 'percentile', ww: 600,  wc: 300,
        title: 'Окно по самому кадру (1–99 перцентиль). Затравка 600/300 — только пока кадр не готов' },
      { id: 'mr-flair', label: 'FLAIR', auto: 'percentile', ww: 1200, wc: 600,
        title: 'Окно по самому кадру (1–99 перцентиль). Затравка 1200/600 — только пока кадр не готов' },
      { id: 'mr-dwi',   label: 'DWI',   auto: 'percentile', ww: 1000, wc: 500,
        title: 'Окно по самому кадру (1–99 перцентиль). Затравка 1000/500 — только пока кадр не готов' },
    ],
  },
  {
    ключ: 'xr', заголовок: 'Рентген', чипы: [
      { id: 'xr-chest', label: 'Грудная кл.', ww: 2048, wc: 1024 },
      { id: 'xr-bone',  label: 'Кости',       ww: 2500, wc: 1000 },
      { id: 'xr-soft',  label: 'Мягк. ткани', ww: 400,  wc: 200 },
      // [10.3.2] У съёмки с С-дуги в тегах нет WindowCenter/Width, диапазон
      // зависит от аппарата и дозы — окно считается по кадру. Затравки нет
      // нарочно: типовых чисел у XA не существует.
      { id: 'xa-auto',  label: 'Ангио (кино)', auto: 'percentile',
        title: 'Окно по самому кадру: 1–99 перцентиль' },
    ],
  },
  {
    ключ: 'other', заголовок: 'Другое', чипы: [
      { id: 'mg-mammo', label: 'Маммо', ww: 2048,  wc: 1024 },
      { id: 'nm',       label: 'NM',    ww: 256,   wc: 128 },
      { id: 'pt-pet',   label: 'PET',   ww: 30000, wc: 15000 },
      { id: 'us',       label: 'US',    ww: 255,   wc: 128 },
    ],
  },
];

export const ГРУППЫ_ЧИПОВ = _ГРУППЫ;

/** Быстрый доступ по id — для _QUICK_WL и проверок. */
export const ЧИПЫ_ПО_ID = Object.freeze(Object.fromEntries(
  _ГРУППЫ.flatMap((г) => г.чипы).map((ч) => [ч.id, ч])));

const _экр = (s) => String(s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/**
 * HTML одного чипа. aria-pressed ставится сразу (аудит §2.5) — переключает
 * его обработчик в sidebarBindings.
 * @param {ЧипОкна} ч
 */
export function chipHtml(ч) {
  const а = [`class="preset-chip"`, `data-window-preset="${_экр(ч.id)}"`, `aria-pressed="false"`];
  if (ч.auto) а.push(`data-wl-auto="1"`);
  if (ч.ww != null) а.push(`data-ww="${ч.ww}"`);
  if (ч.wc != null) а.push(`data-wc="${ч.wc}"`);
  if (ч.title) а.push(`title="${_экр(ч.title)}"`);
  return `<button ${а.join(' ')}>${_экр(ч.label)}</button>`;
}

/**
 * Пределы шкалы ручных ползунков — из максимумов каталога, а не из чисел,
 * зашитых в разметку (аудит §2.1). Затравки МРТ тоже в счёт: их применяют.
 * Нижняя граница уровня не поднимается выше −2000 (нужна КТ-лёгким).
 */
export function пределыШкалы() {
  const все = _ГРУППЫ.flatMap((г) => г.чипы);
  const ww = все.map((ч) => ч.ww).filter(Number.isFinite);
  const wc = все.map((ч) => ч.wc).filter(Number.isFinite);
  return {
    wwMax: Math.max(8000, ...ww),
    wcMax: Math.max(4000, ...wc),
    wcMin: Math.min(-2000, ...wc),
  };
}

export default { ГРУППЫ_ЧИПОВ, ЧИПЫ_ПО_ID, chipHtml, пределыШкалы };
